import { useKeycloak } from "../../src/useKeycloak";
import { gql, NetworkStatus, useLazyQuery, useQuery } from "@apollo/client";
import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLoader } from "@fortawesome/pro-solid-svg-icons";
import Activities from "./index";

export const ACTIVITY_MORE_FILTERS_UPDATED = gql`
	query GetQueueItems(
		$userId: uuid = ""
		$limit: Int
		$offset: Int = 0
		$in: [ActivityStatusEnum!]!
		$inResponsibility: [String!]
		$inType: [String!]
		$oldTypes: [ActivityTypeEnum!]
		$inDirection: [ActivityDirectionEnum!]
		$includeConvos: Boolean = true
		$addDelegated: Boolean = true
		$isMine: Boolean = true
		$meResponsible: Boolean = true
		$includeOldSchool: Boolean = true
		$someoneResponsible: Boolean = false
		$onlyUnanswered: Boolean = false
		$countUnanswered: Boolean = true
		$order: [queueItemOrderBy!]
	) {
		queueItems(
			limit: $limit
			offset: $offset
			where: {
				status: { _in: $in }
				participants: { userId: { _eq: $userId } }
				_and: [
					{
						_or: [
							{ flexibilityType: { _isNull: $includeConvos } }
							{ flexibilityType: { _isNull: $includeOldSchool } }
							{ flexibilityType: { _eq: "AGREED" } }
							{ flexibilityType: { _eq: "OTHER" } }
						]
					}
					{
						_or: [
							{
								queueParticipants: {
									organizationUser: { userId: { _eq: $userId } }
									_and: [
										{
											_or: [
												{ responsible: { _eq: $meResponsible } }
												{ responsible: { _eq: $addDelegated } }
											]
										}
										{
											_or: [
												{ owner: { _eq: true } }
												{ owner: { _eq: false }, responsible: { _eq: true } }
												{ responsible: { _eq: true }, owner: { _eq: false } }
												{ responsible: { _eq: true }, owner: { _isNull: true } }
											]
										}
									]
								}
							}
							{ flexibilityType: { _isNull: true } }
						]
					}
					{
						_or: [
							{ flexibilityType: { _in: $inType } }
							{
								_and: [
									{ flexibilityType: { _isNull: true } }
									{ _not: { flexibilityType: { _in: $inType } } }
								]
							}
							{
								_and: [
									{ flexibilityType: { _isNull: true } }
									{ flexibilityType: { _isNull: $includeConvos } }
								]
							}
							{
								_and: [
									{ flexibilityType: { _isNull: true } }
									{ flexibilityType: { _isNull: $includeOldSchool } }
									{ domainActivity: { type: { _in: $oldTypes } } }
								]
							}
						]
					}
					{
						_or: [
							{ queueParticipants: { responsible: { _eq: $someoneResponsible } } }
							{
								_and: [
									{ flexibilityType: { _isNull: true } }
									{ flexibilityType: { _isNull: $includeConvos } }
								]
							}
							{
								_and: [
									{ flexibilityType: { _isNull: true } }
									{ flexibilityType: { _isNull: $includeOldSchool } }
									{ domainActivity: { type: { _in: $oldTypes } } }
								]
							}
						]
					}
					{
						_or: [
							{ domainActivity: { direction: { _eq: OUTGOING }, startedAt: { _isNull: false } } }
							{ domainActivity: { direction: { _eq: INCOMING }, startedAt: { _isNull: false } } }
							{
								_and: [
									{ domainActivity: { direction: { _eq: INCOMING } } }
									{ domainActivity: { startedAt: { _isNull: true } } }
									{ domainActivity: { startedAt: { _isNull: $countUnanswered } } }
								]
							}
							{
								_and: [
									{ flexibilityType: { _in: $inType } }
									{ flexibilityType: { _isNull: $includeConvos } }
								]
							}
						]
					}
					{
						_or: [
							{ domainActivity: { direction: { _in: $inDirection } } }
							{ domainActivity: { direction: { _isNull: true } } }
							{
								_and: [
									{ flexibilityType: { _in: $inType } }
									{ flexibilityType: { _isNull: $includeConvos } }
								]
							}
							{
								_and: [
									{ flexibilityType: { _isNull: true } }
									{ flexibilityType: { _isNull: $includeOldSchool } }
									{ domainActivity: { type: { _in: $oldTypes } } }
								]
							}
						]
					}
					{
						_or: [
							{
								_and: [
									{ flexibilityType: { _in: $inType } }
									{ flexibilityType: { _isNull: $includeConvos } }
								]
							}
							{
								_and: [
									{ domainActivity: { direction: { _eq: INCOMING } } }
									{ domainActivity: { startedAt: { _isNull: $onlyUnanswered } } }
								]
							}
							{ domainActivity: { direction: { _in: $inDirection } } }
							{
								_and: [
									{ flexibilityType: { _isNull: true } }
									{ flexibilityType: { _isNull: $includeOldSchool } }
									{ domainActivity: { type: { _in: $oldTypes } } }
								]
							}
						]
					}
				]
			}
			orderBy: $order
		) {
			status
			type
			flexibilityType
			subType
			dueDate
			createdByUserId
			private
			id
			title
			additionalData
			createdByUserId
			subTitle
			createdAt
			updatedAt
			alarms {
				absoluteDate
				alarmSelectionType
			}
			domainUsers {
				id
				firstName
				lastName
				category
				phoneNumber
				updatedAt
				emailAddress
				spamScore
				organizationUser {
					id
					firstName
					lastName
					status
					organizationId
					userId
					company {
						firstName
						id
						lastName
					}
					collaborations {
						from
						private
					}
				}
			}
			queueParticipants {
				id
				responsibility
				responsible
				owner
				contact
				organizationUser {
					id
					userId
					firstName
					lastName
					phoneNumber
					role
					company {
						firstName
						id
						lastName
					}
					collaborations {
						from
						private
					}
				}
			}
			domainActivity {
				domain
				id
				provider
				direction
				startedAt
				additionalData
				type
			}
			messages {
				id
				userId
				type
				content
				updatedAt
				user {
					id
					firstName
				}
			}
			organizationUsers {
				company {
					firstName
					id
					lastName
				}
				id
				role
				userId
				status
				organizationId
			}
		}
	}
`;

export const COUNT_TASKS_2 = gql`
	query CountTasks(
		$in: [ActivityTypeEnum!]!
		$status: [ActivityStatusEnum!]!
		$userId: uuid!
		$inType: [String!]
		$inResponsibility: [String!]
		$isMine: Boolean = true
		$meResponsible: Boolean = true
		$someoneResponsible: Boolean = true
		$includeConvos: Boolean = true
		$inDirection: [ActivityDirectionEnum!] = [UNDEFINED]
		$onlyUnanswered: Boolean = false
	) {
		queueItemsAggregate(
			where: {
				status: { _in: $status }
				participants: { userId: { _eq: $userId } }
				_and: [
					{ _or: [{ type: { _in: TASK } }, { domainActivity: { type: { _in: $in } } }] }
					{
						_or: [
							{ flexibilityType: { _isNull: $includeConvos } }
							{ flexibilityType: { _eq: "AGREED" } }
							{ flexibilityType: { _eq: "OTHER" } }
						]
					}
					{
						_or: [
							{
								queueParticipants: {
									organizationUser: { userId: { _eq: $userId } }
									_and: [
										{ responsible: { _eq: $meResponsible } }
										{
											_or: [
												{ owner: { _eq: true } }
												{ owner: { _eq: false }, responsible: { _eq: true } }
												{ responsible: { _eq: true }, owner: { _eq: false } }
												{ responsible: { _eq: true }, owner: { _isNull: true } }
											]
										}
									]
								}
							}
							{ flexibilityType: { _isNull: true } }
						]
					}
					{
						_or: [
							{ flexibilityType: { _in: $inType } }
							{
								_and: [
									{ flexibilityType: { _isNull: true } }
									{ _not: { flexibilityType: { _in: $inType } } }
								]
							}
							{
								_and: [
									{ flexibilityType: { _isNull: true } }
									{ flexibilityType: { _isNull: $includeConvos } }
								]
							}
						]
					}
					{
						_or: [
							{ queueParticipants: { responsible: { _eq: $someoneResponsible } } }
							{
								_and: [
									{ flexibilityType: { _isNull: true } }
									{ flexibilityType: { _isNull: $includeConvos } }
								]
							}
						]
					}
					{
						_or: [
							# Case when $direction is null
							{ type: { _in: TASK } }
							{ domainActivity: { direction: { _isNull: true } } }
							# Case when $direction contains specific values
							{
								_and: [
									{ domainActivity: { direction: { _in: $inDirection } } }
									{ domainActivity: { startedAt: { _isNull: $onlyUnanswered } } }
								]
							}
						]
					}
				]
			}
		) {
			aggregate {
				count
			}
		}
	}
`;

export const GET_NEW_ACTIVITIES_UPDATED = gql`
	subscription getNewActivityQueueItems($userId: uuid = "", $date: timestamptz!) {
		queueItems(
			where: {
				_or: [
					{ messages: { updatedAt: { _gt: $date } } }
					{ updatedAt: { _gt: $date } }
					{ domainUsers: { updatedAt: { _gt: $date } } }
				]
				participants: { userId: { _eq: $userId } }
			}
			orderBy: { dueDate: ASC_NULLS_LAST, createdAt: DESC }
		) {
			status
			type
			flexibilityType
			subType
			dueDate
			createdByUserId
			private
			id
			title
			additionalData
			createdByUserId
			subTitle
			createdAt
			updatedAt
			alarms {
				absoluteDate
				alarmSelectionType
			}
			domainUsers {
				id
				firstName
				lastName
				category
				phoneNumber
				updatedAt
				emailAddress
				organizationUser {
					id
					firstName
					lastName
					status
					organizationId
				}
			}
			queueParticipants {
				id
				responsibility
				responsible
				owner
				contact
				organizationUser {
					id
					userId
					firstName
					lastName
					phoneNumber
					role
					company {
						firstName
						id
						lastName
					}
					collaborations {
						from
						private
					}
				}
			}
			domainActivity {
				domain
				id
				provider
				direction
				startedAt
				additionalData
				type
			}
			messages {
				id
				userId
				type
				content
				updatedAt
				user {
					id
					firstName
				}
			}
			organizationUsers {
				id
				role
				userId
				status
				organizationId
			}
		}
	}
`;

export const FetchActivities = (props) => {
	const { tokenParsed } = useKeycloak();
	//const { colors } = useTheme();
	const [term, setTerm] = useState("");
	const [mainState, setMainState] = useState(0);

	const [assignedCount, setAssignedCount] = useState(0);
	const [otherCount, setOtherCount] = useState(0);
	const [delegatedCount, setDelegatedCount] = useState(0);
	const [conversationsCount, setConversationsCount] = useState(0);
	const [conversationsIncomingCount, setConversationsIncomingCount] = useState(0);
	const [conversationsOutgoingCount, setConversationsOutgoingCount] = useState(0);
	const [conversationsUnansweredCount, setConversationsUnansweredCount] = useState(0);
	const [actualCallItemsData, setActualCallItemsData] = useState([]);

	const [responsibilityFilter, setResponsibilityFilter] = useState(["MINE", "DELEGATED"]);
	const [directionFilter, setDirectionFilter] = useState([]);
	const [typeFilter, setTypeFilter] = useState(["AGREED", "OTHER"]);
	const [queueItems, setQueueItems] = useState([]);

	const [filter, setFilter] = useState([
		"ASSIGNED",
		"INPROGRESS",
		"PAUSED" /*, 'BLOCKED', 'SCHEDULED_FOR_DELETION', 'HIDDEN',*/
		/*'UNASSIGNED',
    'DONE',
    'LOGGED'*/
	]);
	//Assigned tasks
	const { data: assignedCountData, loading: loadingAssignedCount } = useQuery(COUNT_TASKS_2, {
		variables: {
			userId: tokenParsed?.sub,
			in: [
				"GENERAL",
				"TASK",
				"MESSAGING",
				"DRAFT",
				"CONFERENCE",
				"ACTION",
				"MAIL",
				"REMINDER",
				"CALLTO"
			],
			status: ["ASSIGNED", "INPROGRESS", "PAUSED"],
			inType: ["AGREED"],
			includeConvos: false,
			inResponsibility: ["MINE"],
			isMine: true,
			meResponsible: true,
			someoneResponsible: true
		},
		fetchPolicy: "cache-and-network",
		pollInterval: 10000
	});
	//Other tasks
	const { data: otherCountData, loading: loadingOtherCount } = useQuery(COUNT_TASKS_2, {
		variables: {
			userId: tokenParsed?.sub,
			in: [
				"GENERAL",
				"TASK",
				"MESSAGING",
				"DRAFT",
				"CONFERENCE",
				"ACTION",
				"MAIL",
				"REMINDER",
				"CALLTO"
			],
			status: ["ASSIGNED", "INPROGRESS", "PAUSED"],
			inType: ["OTHER"],
			includeConvos: false,
			inResponsibility: ["MINE"],
			isMine: true,
			meResponsible: true,
			someoneResponsible: true
		},
		fetchPolicy: "cache-and-network",
		pollInterval: 10000
	});

	const { data: delegatedCountData, loading: loadingDelegatedCount } = useQuery(COUNT_TASKS_2, {
		variables: {
			userId: tokenParsed?.sub,
			in: [
				"GENERAL",
				"TASK",
				"MESSAGING",
				"DRAFT",
				"CONFERENCE",
				"ACTION",
				"MAIL",
				"REMINDER",
				"CALLTO"
			],
			status: ["ASSIGNED", "INPROGRESS", "PAUSED"],
			inType: ["AGREED", "OTHER"],
			includeConvos: false,
			inResponsibility: ["DELEGATED"],
			isMine: true,
			meResponsible: false,
			someoneResponsible: true,
			direction: ["UNDEFINED"],
			onlyUnanswered: false
		},
		fetchPolicy: "cache-and-network",
		pollInterval: 10000
	});

	/*
    "mine" skal ha de der jeg er satt som responsible, uavhengig av om jeg er owner   (altså owner=true/false, responsible=true)
    "delegated" skal ha de der jeg er satt som owner og noen andre er satt som responsible
   */
	const limit = 20;
	const [startDate, setStartDate] = useState(new Date().toISOString());

	let actualDirection = !typeFilter.includes("CONVERSATIONS")
		? ["UNDEFINED"]
		: directionFilter.includes("UNANSWERED") &&
		directionFilter.length === 1 &&
		typeFilter.includes("CONVERSATIONS")
			? ["INCOMING"]
			: directionFilter.indexOf("UNANSWERED") > -1
				? directionFilter.splice(directionFilter.indexOf("UNANSWERED"), 1)
				: directionFilter;
	if (actualDirection.indexOf("UNANSWERED") > -1) {
		actualDirection = ["INCOMING"];
	}

	const [getQueueItemsActivityMoreFiltersUpdated,
		{ data, loading, networkStatus, error, fetchMore, subscribeToMore, refetch }] = useLazyQuery(
		ACTIVITY_MORE_FILTERS_UPDATED,
		{
			notifyOnNetworkStatusChange: true,
			fetchPolicy: "cache-and-network",
			variables: {
				userId: tokenParsed.sub,
				limit,
				offset: 0,
				in: typeFilter.includes("CONVERSATIONS") ? ["UNASSIGNED", "DONE", "LOGGED"] : filter,
				inType: responsibilityFilter.includes("DELEGATED")
					? typeFilter.filter((type) => type !== "CONVERSATIONS")
					: typeFilter,
				inResponsibility: responsibilityFilter,
				inDirection: actualDirection,
				includeOldSchool:
					responsibilityFilter.includes("MINE") &&
					["OTHER", "AGREED"].every((type) => typeFilter.includes(type)),
				oldTypes: [
					"GENERAL",
					"TASK",
					"MESSAGING",
					"DRAFT",
					"CONFERENCE",
					"ACTION",
					"MAIL",
					"REMINDER",
					"CALLTO"
				],
				includeConvos:
					typeFilter.includes("CONVERSATIONS") && responsibilityFilter.includes("MINE"), //kan ikke delegere samtaler ennå
				isMine: true, //true OG false når MINE, true når DELEGATED
				addDelegated:
					!responsibilityFilter.length === 2 ||
					(responsibilityFilter.includes("MINE") && responsibilityFilter.length === 1),
				meResponsible: responsibilityFilter.includes("MINE"),
				someoneResponsible:
					responsibilityFilter.includes("DELEGATED") ||
					typeFilter.includes("OTHER") ||
					typeFilter.includes("AGREED"),
				onlyUnanswered:
					(directionFilter.includes("UNANSWERED") &&
						directionFilter.length === 1 &&
						typeFilter.includes("CONVERSATIONS")) ||
					directionFilter.length === 2,
				countUnanswered: directionFilter.includes("UNANSWERED") || directionFilter.length === 2,
				order: {
					createdAt: "DESC"
				}
			}
		}
	);

	const headerTabClick = (tabIndex, filterL = [], typeFilterL = [], responsibilityFilterL = [], directionFilterL = []) => {
		setFilter(filterL);
		setTypeFilter(typeFilterL);
		setResponsibilityFilter(responsibilityFilterL);
		setDirectionFilter(directionFilterL);
		let actualDirectionL = !typeFilterL.includes("CONVERSATIONS")
			? ["UNDEFINED"]
			: directionFilterL.includes("UNANSWERED") &&
			directionFilterL.length === 1 &&
			typeFilterL.includes("CONVERSATIONS")
				? ["INCOMING"]
				: directionFilterL.indexOf("UNANSWERED") > -1
					? directionFilterL.splice(directionFilterL.indexOf("UNANSWERED"), 1)
					: directionFilterL;
		if (actualDirectionL.indexOf("UNANSWERED") > -1) {
			actualDirectionL = ["INCOMING"];
		}
		getQueueItemsActivityMoreFiltersUpdated({
			notifyOnNetworkStatusChange: true,
			fetchPolicy: "cache-and-network",
			variables: {
				userId: tokenParsed.sub,
				limit,
				offset: 0,
				in: typeFilterL.includes("CONVERSATIONS") ? ["UNASSIGNED", "DONE", "LOGGED"] : filterL,
				inType: responsibilityFilterL.includes("DELEGATED")
					? typeFilterL.filter((type) => type !== "CONVERSATIONS")
					: typeFilterL,
				inResponsibility: responsibilityFilterL,
				inDirection: actualDirectionL,
				includeOldSchool:
					responsibilityFilterL.includes("MINE") &&
					["OTHER", "AGREED"].every((type) => typeFilterL.includes(type)),
				oldTypes: [
					"GENERAL",
					"TASK",
					"MESSAGING",
					"DRAFT",
					"CONFERENCE",
					"ACTION",
					"MAIL",
					"REMINDER",
					"CALLTO"
				],
				includeConvos:
					typeFilterL.includes("CONVERSATIONS") && responsibilityFilterL.includes("MINE"), //kan ikke delegere samtaler ennå
				isMine: true, //true OG false når MINE, true når DELEGATED
				addDelegated:
					!responsibilityFilterL.length === 2 ||
					(responsibilityFilterL.includes("MINE") && responsibilityFilterL.length === 1),
				meResponsible: responsibilityFilterL.includes("MINE"),
				someoneResponsible:
					responsibilityFilterL.includes("DELEGATED") ||
					typeFilterL.includes("OTHER") ||
					typeFilterL.includes("AGREED"),
				onlyUnanswered:
					(directionFilterL.includes("UNANSWERED") &&
						directionFilterL.length === 1 &&
						typeFilterL.includes("CONVERSATIONS")) ||
					directionFilterL.length === 2,
				countUnanswered: directionFilterL.includes("UNANSWERED") || directionFilterL.length === 2,
				order: {
					createdAt: "DESC"
				}
			}
		}).then(
			(res) => {

			}
		);
	};

	useEffect(() => {
		//Filtrerer faktiske data for hver spørring
		if (data) {
			console.log("Activities data changed", new Date().toISOString());
			const actualCallItems = data?.queueItems?.filter((queueItem) => {
				if (queueItem?.domainActivity?.domain === "TELEPHONY") {
					if (
						(directionFilter.includes(queueItem?.domainActivity?.direction) &&
							queueItem?.domainActivity?.startedAt) ||
						(directionFilter.length === 2 && !queueItem?.domainActivity?.startedAt) ||
						(directionFilter.includes("UNANSWERED") &&
							directionFilter.length === 1 &&
							typeFilter.includes("CONVERSATIONS") &&
							!queueItem?.domainActivity?.startedAt)
					) {
						return queueItem;
					}
				}
			});
			setActualCallItemsData(actualCallItems);
			const queueItemsL = typeFilter?.includes("CONVERSATIONS")
				? actualCallItems
				: data?.queueItems?.filter((item) => filter?.includes(item?.status)) || [];

			setQueueItems(queueItemsL);
		}
	}, [data]);

	// useEffect(() => {
	// 	if (
	// 		filter != null &&
	// 		typeFilter != null &&
	// 		responsibilityFilter != null &&
	// 		directionFilter != null
	// 	) {
	// 		console.log("do refetch");
	// 		refetch();
	// 	}
	// }, [filter, typeFilter, responsibilityFilter, directionFilter]);

	useEffect(() => {
		//Filtrerer counters for hver header
		if (assignedCountData) {
			const count =
				assignedCountData?.queueItemsAggregate?.aggregate?.count > 99
					? "99+"
					: assignedCountData?.queueItemsAggregate?.aggregate?.count;
			setAssignedCount(count);
		}
		if (otherCountData) {
			const count =
				otherCountData?.queueItemsAggregate?.aggregate?.count > 99
					? "99+"
					: otherCountData?.queueItemsAggregate?.aggregate?.count;
			setOtherCount(count);
		}
		if (delegatedCountData) {
			const count =
				delegatedCountData?.queueItemsAggregate?.aggregate?.count > 99
					? "99+"
					: delegatedCountData?.queueItemsAggregate?.aggregate?.count;
			setDelegatedCount(count);
		}
	}, [
		assignedCountData,
		otherCountData,
		delegatedCountData
	]);

	useEffect(() => {
		//console.log('Subscribing to new activities');
		const unsubscribe = subscribeToMore({
			document: GET_NEW_ACTIVITIES_UPDATED,
			variables: {
				userId: tokenParsed.sub,
				date: startDate
			},
			fetchPolicy: "cache-and-network",
			updateQuery: (prev, { subscriptionData }) => {
				if (!subscriptionData.data?.queueItems) return prev;

				const oldQueueItems = [...(prev?.queueItems || [])];
				subscriptionData.data.queueItems.map((item) => {
					const index = oldQueueItems.findIndex((oldItem) => oldItem.id === item.id);
					if (filter?.includes(item.status)) {
						if (index >= 0) {
							oldQueueItems[index] = item;
						}
						else {
							oldQueueItems.unshift(item);
						}
					}
					else if (index >= 0) {
						oldQueueItems.splice(index, 1);
					}
				});
				const newQueueItems = oldQueueItems;//?.filter((q) => !q.isOptimistic);

				return {
					...prev,
					queueItems: newQueueItems.sort((a, b) => {
						if (a.createdAt > b.createdAt) return -1;
						if (a.createdAt < b.createdAt) return 1;
						return 0;
					})
				};
			}
		});
		return () => {
			unsubscribe();
		};
	}, [subscribeToMore, filter]);

	//For samtaler bruker vi samtaledata som er filtrert, ellers rådata fra spørringen
	// const queueItems = typeFilter?.includes("CONVERSATIONS")
	// 	? actualCallItemsData
	// 	: data?.queueItems?.filter((item) => filter?.includes(item?.status)) || [];
	//console.log("queueItems actualCallItemsData", actualCallItemsData);

	const sortQueueItems = (queueItems) => {
		console.log("sort starts", new Date().toISOString());
		//Her skal vi nå sortere queueItems etter aktive/duedate.
		//Aktive øverst, før fullførte, og etter duedate med utløp nærmest først
		//Trigger uansett bare sortering for de som er assigned , conversations sorteres ikke og følger query order
		const sorted = queueItems.sort((a, b) => {
			if (a.createdAt > b.createdAt) return -1;
			if (a.createdAt < b.createdAt) return 1;
			return 0;
		});

		console.log("sort ends", new Date().toISOString());
		return sorted;
	};

	return (
		<Activities
			{...props}
			data={{
				queueItems
			}}
			loading={loading && !(networkStatus === NetworkStatus.fetchMore)}
			fetchingMore={networkStatus === NetworkStatus.fetchMore}
			error={error}
			filter={filter}
			setFilter={setFilter}
			setResponsibilityFilter={setResponsibilityFilter}
			setDirectionFilter={setDirectionFilter}
			setTypeFilter={setTypeFilter}
			assignedCount={assignedCount}
			otherCount={otherCount}
			delegatedCount={delegatedCount}
			conversationsCount={conversationsCount}
			conversationsIncomingCount={conversationsIncomingCount}
			conversationsOutgoingCount={conversationsOutgoingCount}
			conversationsUnansweredCount={conversationsUnansweredCount}
			loadingDelegatedCount={loadingDelegatedCount}
			loadingAssignedCount={loadingAssignedCount}
			loadingOtherCount={loadingOtherCount}
			term={term}
			privateList={props?.privateList}
			setTerm={setTerm}
			fetchMore={() => {
				fetchMore({
					variables: {
						limit,
						userId: tokenParsed.sub,
						offset: data?.queueItems?.length || 20
					}
				});
			}}
			mainState={mainState}
			setMainState={setMainState}
			headerTabClick = {headerTabClick}
		/>
	);
	// <View style={{ flex: 1, backgroundColor: colors.headerBackground }}>
	// 	<Activity
	// 		{...props}
	// 		data={{
	// 			queueItems /*
	//       queueItems: ['AGREED', 'OTHER'].some((type) => typeFilter.includes(type))
	//         ? sortQueueItems([...queueItems])
	//         : queueItems, //sorterer bare tasks */
	// 		}}
	// 		loading={loading && !(networkStatus === NetworkStatus.fetchMore)}
	// 		fetchingMore={networkStatus === NetworkStatus.fetchMore}
	// 		error={error}
	// 		filter={filter}
	// 		setFilter={setFilter}
	// 		setResponsibilityFilter={setResponsibilityFilter}
	// 		setDirectionFilter={setDirectionFilter}
	// 		setTypeFilter={setTypeFilter}
	// 		assignedCount={assignedCount}
	// 		otherCount={otherCount}
	// 		delegatedCount={delegatedCount}
	// 		conversationsCount={conversationsCount}
	// 		conversationsIncomingCount={conversationsIncomingCount}
	// 		conversationsOutgoingCount={conversationsOutgoingCount}
	// 		conversationsUnansweredCount={conversationsUnansweredCount}
	// 		loadingDelegatedCount={loadingDelegatedCount}
	// 		loadingAssignedCount={loadingAssignedCount}
	// 		loadingOtherCount={loadingOtherCount}
	// 		term={term}
	// 		privateList={props?.privateList}
	// 		setTerm={setTerm}
	// 		fetchMore={() => {
	// 			fetchMore({
	// 				variables: {
	// 					limit,
	// 					userId: tokenParsed.sub,
	// 					offset: data?.queueItems?.length || 20
	// 				}
	// 			});
	// 		}}
	// 		mainState={mainState}
	// 		setMainState={setMainState}
	// 	/>
	// </View>
	// );
};



// export default function OLDFetchActivities(props) {
// 	const { tokenParsed } = useKeycloak();
// 	const [term, setTerm] = useState("");
// 	const [mainState, setMainState] = useState(0);
//
// 	const [assignedCount, setAssignedCount] = useState(0);
// 	const [otherCount, setOtherCount] = useState(0);
// 	const [delegatedCount, setDelegatedCount] = useState(0);
// 	const [conversationsCount, setConversationsCount] = useState(0);
// 	const [conversationsIncomingCount, setConversationsIncomingCount] = useState(0);
// 	const [conversationsOutgoingCount, setConversationsOutgoingCount] = useState(0);
// 	const [conversationsUnansweredCount, setConversationsUnansweredCount] = useState(0);
// 	const [actualCallItemsData, setActualCallItemsData] = useState([]);
//
// 	const [responsibilityFilter, setResponsibilityFilter] = useState(["MINE", "DELEGATED"]);
// 	const [directionFilter, setDirectionFilter] = useState(["INCOMING", "OUTGOING", "UNANSWERED"]);
// 	const [typeFilter, setTypeFilter] = useState(["AGREED", "OTHER"]);
//
// 	const [filter, setFilter] = useState([
// 		"ASSIGNED",
// 		"INPROGRESS",
// 		"PAUSED" /*, 'BLOCKED', 'SCHEDULED_FOR_DELETION', 'HIDDEN',*/
// 		/*'UNASSIGNED',
//     'DONE',
//     'LOGGED'*/
// 	]);
// 	//Assigned tasks
// 	const { data: assignedCountData, loading: loadingAssignedCount } = useCountTasksQuery( {
// 		variables: {
// 			userId: tokenParsed?.sub,
// 			in: [
// 				"GENERAL",
// 				"TASK",
// 				"MESSAGING",
// 				"DRAFT",
// 				"CONFERENCE",
// 				"ACTION",
// 				"MAIL",
// 				"REMINDER",
// 				"CALLTO"
// 			],
// 			status: ["ASSIGNED", "INPROGRESS", "PAUSED"],
// 			inType: ["AGREED"],
// 			includeConvos: false,
// 			inResponsibility: ["MINE"],
// 			isMine: true,
// 			meResponsible: true,
// 			someoneResponsible: true
// 		},
// 		fetchPolicy: "cache-and-network",
// 		pollInterval: 10000
// 	});
// 	//Other tasks
// 	const { data: otherCountData, loading: loadingOtherCount } = useCountTasksQuery( {
// 		variables: {
// 			userId: tokenParsed?.sub,
// 			in: [
// 				"GENERAL",
// 				"TASK",
// 				"MESSAGING",
// 				"DRAFT",
// 				"CONFERENCE",
// 				"ACTION",
// 				"MAIL",
// 				"REMINDER",
// 				"CALLTO"
// 			],
// 			status: ["ASSIGNED", "INPROGRESS", "PAUSED"],
// 			inType: ["OTHER"],
// 			includeConvos: false,
// 			inResponsibility: ["MINE"],
// 			isMine: true,
// 			meResponsible: true,
// 			someoneResponsible: true
// 		},
// 		fetchPolicy: "cache-and-network",
// 		pollInterval: 10000
// 	});
//
// 	const { data: delegatedCountData, loading: loadingDelegatedCount } = useCountTasksQuery( {
// 		variables: {
// 			userId: tokenParsed?.sub,
// 			in: [
// 				"GENERAL",
// 				"TASK",
// 				"MESSAGING",
// 				"DRAFT",
// 				"CONFERENCE",
// 				"ACTION",
// 				"MAIL",
// 				"REMINDER",
// 				"CALLTO"
// 			],
// 			status: ["ASSIGNED", "INPROGRESS", "PAUSED"],
// 			inType: ["AGREED", "OTHER"],
// 			includeConvos: false,
// 			inResponsibility: ["DELEGATED"],
// 			isMine: true,
// 			meResponsible: false,
// 			someoneResponsible: true,
// 			direction: ["UNDEFINED"],
// 			onlyUnanswered: false
// 		},
// 		fetchPolicy: "cache-and-network",
// 		pollInterval: 10000
// 	});
//
// 	/*
// 		"mine" skal ha de der jeg er satt som responsible, uavhengig av om jeg er owner   (altså owner=true/false, responsible=true)
// 		"delegated" skal ha de der jeg er satt som owner og noen andre er satt som responsible
// 	 */
// 	const limit = 20;
// 	const [startDate, setStartDate] = useState(new Date().toISOString());
// 	//eslint-disable-next-line
//   let actualDirection = !typeFilter.includes('CONVERSATIONS')
// 		? ["UNDEFINED"]
// 		: directionFilter.includes("UNANSWERED") &&
//     directionFilter.length === 1 &&
//     typeFilter.includes("CONVERSATIONS")
// 			? ["INCOMING"]
// 			: directionFilter.indexOf("UNANSWERED") > -1
// 				? directionFilter.splice(directionFilter.indexOf("UNANSWERED"), 1)
// 				: directionFilter;
// 	if (actualDirection.indexOf("UNANSWERED") > -1) {
// 		actualDirection = ["INCOMING"];
// 	}
//
// 	const { data, loading, networkStatus, error, fetchMore, subscribeToMore, refetch } = useGetQueueItemsActivityQuery(
// 		{
// 			notifyOnNetworkStatusChange: true,
// 			fetchPolicy: "cache-and-network",
// 			variables: {
// 				userId: tokenParsed.sub,
// 				limit,
// 				offset: 0,
// 				in: typeFilter.includes("CONVERSATIONS") ? ["UNASSIGNED", "DONE", "LOGGED"] : filter,
// 				inType: responsibilityFilter.includes("DELEGATED")
// 					? typeFilter.filter((type) => type !== "CONVERSATIONS")
// 					: typeFilter,
// 				inResponsibility: responsibilityFilter,
// 				inDirection: actualDirection,
// 				includeOldSchool:
//           responsibilityFilter.includes("MINE") &&
//           ["OTHER", "AGREED"].every((type) => typeFilter.includes(type)),
// 				oldTypes: [
// 					"GENERAL",
// 					"TASK",
// 					"MESSAGING",
// 					"DRAFT",
// 					"CONFERENCE",
// 					"ACTION",
// 					"MAIL",
// 					"REMINDER",
// 					"CALLTO"
// 				],
// 				includeConvos:
//           typeFilter.includes("CONVERSATIONS") && responsibilityFilter.includes("MINE"), //kan ikke delegere samtaler ennå
// 				isMine: true, //true OG false når MINE, true når DELEGATED
// 				addDelegated:
//           !responsibilityFilter.length === 2 ||
//           (responsibilityFilter.includes("MINE") && responsibilityFilter.length === 1),
// 				meResponsible: responsibilityFilter.includes("MINE"),
// 				someoneResponsible:
//           responsibilityFilter.includes("DELEGATED") ||
//           typeFilter.includes("OTHER") ||
//           typeFilter.includes("AGREED"),
// 				onlyUnanswered:
//           (directionFilter.includes("UNANSWERED") &&
//             directionFilter.length === 1 &&
//             typeFilter.includes("CONVERSATIONS")) ||
//           directionFilter.length === 2,
// 				countUnanswered: directionFilter.includes("UNANSWERED") || directionFilter.length === 2,
// 				order: {
// 					createdAt: "DESC"
// 				}
// 			}
// 		}
// 	);
//
// 	useEffect(() => {
// 		//Filtrerer faktiske data for hver spørring
// 		if (data) {
// 			//console.log('getting data', data?.queueItems?.length);
//
// 			const actualCallItems = data?.queueItems?.filter((queueItem) => {
// 				if (queueItem?.domainActivity?.domain === "TELEPHONY") {
// 					//console.log('queueItem?.domainActivity?.direction', queueItem?.domainActivity?.direction);
// 					if (
// 						(directionFilter.includes(queueItem?.domainActivity?.direction) &&
//               queueItem?.domainActivity?.startedAt) ||
//             (directionFilter.length === 2 && !queueItem?.domainActivity?.startedAt) ||
//             (directionFilter.includes("UNANSWERED") &&
//               directionFilter.length === 1 &&
//               typeFilter.includes("CONVERSATIONS") &&
//               !queueItem?.domainActivity?.startedAt)
// 					) {
// 						return queueItem;
// 					}
// 				}
// 			});
// 			setActualCallItemsData(actualCallItems);
// 		}
// 	}, [data]);
//
// 	useEffect(() => {
// 		if (
// 			filter != null &&
//       typeFilter != null &&
//       responsibilityFilter != null &&
//       directionFilter != null /* && !loading*/
// 		) {
// 			//console.log('do refetch');
// 			refetch();
// 		}
// 	}, [filter, typeFilter, responsibilityFilter, directionFilter]);
//
// 	useEffect(() => {
// 		//Filtrerer counters for hver header
// 		if (assignedCountData) {
// 			//console.log('assignedCountData: ', assignedCountData?.queueItemsAggregate?.aggregate?.count);
// 			const count =
//         assignedCountData?.queueItemsAggregate?.aggregate?.count > 99
//         	? "99+"
//         	: assignedCountData?.queueItemsAggregate?.aggregate?.count;
// 			setAssignedCount(count);
// 		}
// 		if (otherCountData) {
// 			//console.log('otherCountData: ', otherCountData?.queueItemsAggregate?.aggregate?.count);
// 			const count =
//         otherCountData?.queueItemsAggregate?.aggregate?.count > 99
//         	? "99+"
//         	: otherCountData?.queueItemsAggregate?.aggregate?.count;
// 			setOtherCount(count);
// 		}
// 		if (delegatedCountData) {
// 			const count =
//         delegatedCountData?.queueItemsAggregate?.aggregate?.count > 99
//         	? "99+"
//         	: delegatedCountData?.queueItemsAggregate?.aggregate?.count;
// 			setDelegatedCount(count);
// 		}
// 	}, [
// 		assignedCountData,
// 		otherCountData,
// 		delegatedCountData
// 	]);
//
// 	useEffect(() => {
// 		//console.log('Subscribing to new activities');
// 		const unsubscribe = subscribeToMore({
// 			document: GET_NEW_ACTIVITIES_UPDATED,
// 			variables: {
// 				userId: tokenParsed.sub,
// 				date: startDate
// 			},
// 			fetchPolicy: "cache-and-network",
// 			updateQuery: (prev, { subscriptionData }) => {
// 				if (!subscriptionData.data?.queueItems) return prev;
//
// 				const oldQueueItems = [...(prev?.queueItems || [])];
// 				subscriptionData.data.queueItems.map((item) => {
// 					const index = oldQueueItems.findIndex((oldItem) => oldItem.id === item.id);
// 					if (filter?.includes(item.status)) {
// 						if (index >= 0) {
// 							oldQueueItems[index] = item;
// 						}
// 						else {
// 							oldQueueItems.unshift(item);
// 						}
// 					}
// 					else if (index >= 0) {
// 						oldQueueItems.splice(index, 1);
// 					}
// 				});
// 				const newQueueItems = oldQueueItems?.filter((q) => !q.isOptimistic);
//
// 				return {
// 					...prev,
// 					queueItems: newQueueItems.sort((a, b) => {
// 						if (a.createdAt > b.createdAt) return -1;
// 						if (a.createdAt < b.createdAt) return 1;
// 						return 0;
// 					})
// 				};
// 			}
// 		});
// 		return () => {
// 			unsubscribe();
// 		};
// 	}, [subscribeToMore, filter]);
//
// 	//For samtaler bruker vi samtaledata som er filtrert, ellers rådata fra spørringen
// 	const queueItems = typeFilter?.includes("CONVERSATIONS")
// 		? actualCallItemsData
// 		: data?.queueItems?.filter((item) => filter?.includes(item?.status)) || [];
//
// 	const sortQueueItems = (queueItems) => {
// 		console.log("sort starts", new Date().toISOString());
// 		//Her skal vi nå sortere queueItems etter aktive/duedate.
// 		//Aktive øverst, før fullførte, og etter duedate med utløp nærmest først
// 		//Trigger uansett bare sortering for de som er assigned , conversations sorteres ikke og følger query order
//
// 		const sorted = queueItems.sort((a, b) => {
// 			if (a.createdAt > b.createdAt) return -1;
// 			if (a.createdAt < b.createdAt) return 1;
// 			return 0;
// 		});
//
// 		console.log("sort ends", new Date().toISOString());
// 		return sorted;
// 	};
//
// 	return (
// 		<Box>
// 			{loading &&
//         <FontAwesomeIcon icon={faLoader}/>
// 			}
// 			{props.children}
// 		</Box>
// 	);
// };
